// src/components/VideoBackground.tsx
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Chip,
  IconButton,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import theme from "../theme";
import { useInView } from "react-intersection-observer";
import CountdownChip from "./CountdownChip"; // Adjust the path as necessary

import {
  ArrowDropDownCircle,
  ArrowForwardIosOutlined,
  Launch,
} from "@mui/icons-material";

interface VideoBackgroundProps {
  videoSrc: string;
  overlayTextmini?: string;
  overlayText: string;
  overlayText2?: string;
  overlayText3?: string;
  launched: boolean;
}

const VideoBackground: React.FC<VideoBackgroundProps> = ({
  launched,
  videoSrc,
  overlayTextmini,
  overlayText,
  overlayText2,
  overlayText3,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleClick = () => {
    // Calculate the target position as 100vh from the current scroll position
    const targetPosition = window.scrollY + window.innerHeight;

    // Scroll to the target position
    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Box
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
          //marginBottom: "250px",
        }}
      >
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",

            background:
              "linear-gradient(rgba(13, 17, 23, 0.8), rgba(13, 17, 23, 0.4), rgba(13, 17, 23, 0), rgba(13, 17, 23, 0.6), rgba(13, 17, 23, 1))",
          }}
        ></div>
        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            bottom: isMobile ? "10%" : "0px", // Adjust bottom position based on screen size
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            maxWidth: "1300px",
            padding: isMobile ? "0 20px" : "0 90px 0 33px", // Adjust padding for mobile view
            boxSizing: "border-box",
          }}
        ></div>

        {/* Material-UI Chip */}
        <Box
          style={{
            position: "absolute",
            bottom: isMobile ? "20%" : "20%",
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            maxWidth: "1300px",
            padding: isMobile ? "0px 15px 0 15px" : "0px 18px 0 27px",
          }}
        >
          {/*}
          <Chip
            variant="outlined"
            label={
              <span>
                Product in <CountdownChip />
              </span>
            }
            // label="Launcing..."
            sx={{
              color: alpha("#fff", 0.8),
              backgroundColor: alpha("#fff", 0.1),
              fontSize: isMobile ? "10px" : "14px",
              fontWeight: 600,
              height: isMobile ? "25px" : "30px",
              mb: isMobile ? "18px" : "15px",
              justifyContent: "center",
            }}
          />
          */}
          <Typography
            variant={isMobile ? "h6" : "h5"}
            style={{
              color: "white",
              textAlign: "left",
            }}
          >
            {overlayTextmini}{" "}
          </Typography>
          <Typography
            variant={isMobile ? "h4" : "h2"}
            style={{
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            {overlayText}
          </Typography>
          <Typography
            variant={isMobile ? "body1" : "h5"}
            sx={{
              fontWeight: 400,

              textAlign: "left",
              //color: "text.secondary",
            }}
          >
            {overlayText2}
            {isMobile ? " " : <br />}

            {overlayText3}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            maxWidth: "1300px",
            padding: "0 33px",
            marginTop: "10px",
          }}
        >
          {/*
          {launched && (
            
            <FadeInView2>
              <Box
                sx={{
                  width: "100%",
                  //marginBottom: isMobile ? 10 : 22,
                }}
              >
                <Typography
                  variant={isMobile ? "body2" : "h5"}
                  sx={{
                    fontWeight: 500,
                    textAlign: "left",
                    color: "text.secondary",
                  }}
                  component="div"
                  gutterBottom
                >
                  Enhance teamwork and productivity with structured, reusable
                  data and documents.
                  {!isMobile && <br />} Streamline processes to boost your win
                  rate.
                </Typography>
              </Box>
            </FadeInView2>
           
          )}

           */}
        </Box>
        {launched && (
          <Box
            sx={{
              position: "absolute",
              bottom: 20,
              left: 0,
              right: 0,
              marginLeft: "auto",
              marginRight: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              animation: "fadeIn 1s ease-in-out",
              "@keyframes fadeIn": {
                "0%": { opacity: 0 },
                "100%": { opacity: 1 },
              },
            }}
            onClick={handleClick} // Add click handler here
            style={{ cursor: "pointer" }}
          >
            <ArrowForwardIosOutlined
              sx={{
                fontSize: "18px",
                rotate: "90deg",
                animation: "fadeArrowFirst 3s infinite",
                "@keyframes fadeArrowFirst": {
                  "0%": { opacity: 0 },
                  "50%": { opacity: 1 },
                  "100%": { opacity: 0 },
                },
              }}
            />
            <ArrowForwardIosOutlined
              sx={{
                fontSize: "19px",
                mt: -1,
                animation: "fadeArrowSecond 3s infinite",
                rotate: "90deg",
                animationDelay: "0.6s", // Delay to start after the first arrow
                "@keyframes fadeArrowSecond": {
                  "0%": { opacity: 0 },
                  "50%": { opacity: 1 },
                  "100%": { opacity: 0 },
                },
              }}
            />
            <ArrowForwardIosOutlined
              sx={{
                fontSize: "21px",
                mt: -1,
                animation: "fadeArrowSecond 3s infinite",
                rotate: "90deg",
                animationDelay: "1.2s", // Delay to start after the first arrow
                "@keyframes fadeArrowSecond": {
                  "0%": { opacity: 0 },
                  "50%": { opacity: 1 },
                  "100%": { opacity: 0 },
                },
              }}
            />
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0, fontWeight: "500" }}
            >
              Explore more
            </Typography>
          </Box>
        )}

        {!isMobile && (
          <Button
            onClick={togglePlay}
            sx={{
              position: "absolute",
              bottom: 20,
              right: 30,
              backgroundColor: theme.palette.background.paper,
              color: "white",
              padding: "3",
              borderRadius: 1,

              "&:hover": {
                backgroundColor: "#ffffff",
                color: theme.palette.text.secondary,
                transition: "0.3s ease-in-out",
              },
            }}
            startIcon={isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          >
            {isPlaying ? "Pause" : "Play"}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default VideoBackground;

interface FadeInViewProps {
  children: React.ReactNode;
  zIndex?: number; // Add any other props you need
}
const FadeInView2: React.FC<FadeInViewProps> = ({ children, zIndex }) => {
  const [hasScrolled, setHasScrolled] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0.6,
    triggerOnce: true,
  });

  const handleScroll = () => {
    if (window.scrollY > 0 && !hasScrolled) {
      setHasScrolled(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasScrolled]);

  return hasScrolled ? (
    <div ref={ref} className="fade-in">
      {children}
    </div>
  ) : null;
};
